export const EDIT_STRUCTURED_LOG_MODAL_ID = 'editStructuredLog'
